import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Career from "./pages/Career";
import Portfolio from "./pages/Portfolio";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import ApplicationForm from "./pages/ApplicationForm";
import Loader from "./pages/Loader";
import ContentProtector from "./pages/ContentProtector"; // ✅ Content security layer
import { Helmet } from "react-helmet";
import { Analytics } from "@vercel/analytics/react"

// Styles
import "./App.css";
import "./index.css";
import "nprogress/nprogress.css";
import '@fortawesome/fontawesome-free/css/all.min.css';

// Loading bar
import NProgress from "nprogress";
import GoogleAnalytics from "./pages/GoogleAnalytics";

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    NProgress.start(); // Start loading bar
    const timer = setTimeout(() => {
      setLoading(false);
      NProgress.done(); // End loading bar
    }, 2500);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Loader />;

  return (
    <>

      <Helmet>
        <title>Home | Lavanya Infotech</title>
        <meta name="description" content="Lavanya Infotech offers elegant web solutions, branding and UI/UX development." />
        <meta name="keywords" content="Lavanya Infotech, Web Development, UI UX, IT Company India" />
      </Helmet>
      <GoogleAnalytics />
      {/* ✅ Apply global content protection */}
      <ContentProtector />

      {/* ✅ Optional: You can wrap this with <main className="select-none"> to prevent text selection with Tailwind */}
      <div className="app-wrapper">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/career" element={<Career />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/apply" element={<ApplicationForm />} />
        </Routes>
        <Footer />
      </div>
    </>
  );
};

export default App;
